import React, { PropTypes, Component } from 'react';
// import { LocalForm, Control } from 'react-redux-form'
import { Row, Field } from 'react-gridforms';
import trim from 'validator/lib/trim';
import isEmail from 'validator/lib/isEmail';

import Input from 'components/Input';

class FormChangeEmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      invalid: null,
    };
  }

  _onSubmit = (e) => {
    e.preventDefault();
    const email = trim(this._email._input.value);
    if (isEmail(email)) {
      this.setState({
        invalid: null,
      });
      this.props.onSubmit(email);
    } else {
      this.setState({
        invalid: true,
      });
    }
  };

  render() {
    const { invalid } = this.state;
    const { isPending, email, id } = this.props;
    const submitText = isPending ? 'Changing email...' : 'Change Email';

    return (
      <div className='row'>
        <div className='col-sm-5'>
          <h5>Account Email</h5>
          <p className='text-muted'>
            This is the email address where we send announcements,
            notifications, and security details regarding your account.
          </p>
          <br />
          <p className='text-muted'>
            <small>DEFAULT PASSWORD:</small> {'B!su' + id}
          </p>
        </div>
        <div className='col-sm-6'>
          <form className='grid-form' onSubmit={this._onSubmit}>
            <Row>
              <Field>
                <Input
                  type='email'
                  model='.email'
                  ref={(c) => (this._email = c)}
                  label='Email Address'
                  defaultValue={email}
                  required
                  autoFocus
                  disabled
                />
                {invalid && (
                  <div className='text-danger errblock'>
                    <span>* Invalid email.</span>
                  </div>
                )}
              </Field>
            </Row>
            <div className='m-t-20 text-right'>
              <button
                type='submit'
                disabled={isPending}
                className='btn btn-primary'
              >
                {submitText}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

FormChangeEmail.propTypes = {
  email: PropTypes.string,
  id: PropTypes.number,
  isPending: PropTypes.bool,
  onSubmit: PropTypes.func,
};

export default FormChangeEmail;



// WEBPACK FOOTER //
// ./src/containers/Account/form-change-email.js